import { KeyboardArrowDown } from "@mui/icons-material";
import { createTheme } from "@mui/material";

export const theme = createTheme({
  shape: {
    borderRadius: 6,
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    body1: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "150%",
    },
    body2: {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: "150%",
    },
    subtitle1: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: "150%",
    },
    subtitle2: {
      fontWeight: 400,
      fontSize: 18,
      lineHeight: "150%",
    },
    h2: {
      fontWeight: 700,
      fontSize: 30,
      lineHeight: "150%",
    },
    h6: {
      fontWeight: 500,
      fontSize: 20,
      lineHeight: "150%",
    },
  },
  palette: {
    primary: {
      main: "#872EE5",
    },
    secondary: {
      main: "#5E13891A",
    },
    text: {
      primary: "#111928",
      secondary: "#6B7280",
    },
    divider: "#E0E3EB",
    background: {
      default: "#F4F5F7",
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          boxSizing: "border-box",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E0E3EB",
            borderRadius: "8px",
          },
          "& .MuiSvgIcon-root": {
            color: "#9CA3AF",
            fontSize: "20px",
          },
        },
        input: {
          height: "48px",
          boxSizing: "border-box",
          fontWeight: 500,
          fontSize: "14px",
          "&::placeholder": {
            fontWeight: 400,
            fontSize: "14px",
            color: "#9CA3AF",
            opacity: 1,
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        outlined: {
          padding: "12px 16px",
          height: "46px",
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
        },
      },
      defaultProps: {
        IconComponent: KeyboardArrowDown,
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          fontSize: "14px",
          height: "40px",
          padding: "16px 20px",
          fontWeight: 600,
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          fontSize: "14px",
          fontWeight: 500,
        },
        root: {
          "& .MuiInputBase-root": {
            height: "46px",
            "& input": {
              height: "100%",
            },
          },
        },
      },
    },

    MuiSvgIcon: {
      defaultProps: {
        fontSize: "small",
      },
    },

    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: "12px",
        },
      },
    },

    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#d1d5db",
          "&:hover": {
            backgroundColor: "rgba(99, 102, 241, 0.04)",
          },
          "&.Mui-checked": {
            color: "#6366f1",
            "&:hover": {
              backgroundColor: "rgba(99, 102, 241, 0.04)",
            },
          },
          "& .MuiSvgIcon-root": {
            fontSize: 20,
          },
        },
      },
    },

    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#d1d5db",
          borderRadius: "6px",
          "&:hover": {
            backgroundColor: "rgba(99, 102, 241, 0.04)",
          },
          "&.Mui-checked": {
            color: "#6366f1",
            "&:hover": {
              backgroundColor: "rgba(99, 102, 241, 0.04)",
            },
          },
          "& .MuiSvgIcon-root": {
            fontSize: 20,
          },
        },
      },
    },

    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          margin: "8px 0",
          "&:hover": {
            "& .MuiRadio-root, & .MuiCheckbox-root": {
              backgroundColor: "rgba(99, 102, 241, 0.04)",
            },
          },
        },
        label: {
          fontSize: "14px",
          fontWeight: 500,
          color: "#374151",
          marginLeft: "8px",
        },
      },
    },
  },
});
